import React, { Component } from 'react'

export default class ImagePreview extends Component {
  componentDidMount() {
    this.setImage(this.props)
  }
  componentWillReceiveProps(props) {
    this.setImage(props)
  }
  setImage = (props) => {
    const { file } = props
    if (!file)
      return

    if (file.type === 'application/pdf')
      return this.refs.preview.src = '/cdn/img/customer/pdf_icon.png'

    const reader = new FileReader()
    reader.addEventListener("load", () => {
      if (this.refs.preview)
        this.refs.preview.src = reader.result
    }, false)
    reader.readAsDataURL(file)
  }
  render() {
    return (
      <img ref="preview" style={{ maxWidth: '100%', maxHeight: '150px' }} alt="" />
    )
  }
}